/**
 * Keeps the luxury Add to Bag button price in sync with the main product price (under the product name).
 * Copies directly from the live product-price [ref="priceContainer"] element so the button always matches the price on top.
 *
 * SILVIFY B-01 (interim) — On a canonical product URL with no ?variant= param, Liquid left the
 * form's hidden variant input empty and the CTA disabled as "SELECT OPTIONS", so every visitor
 * arriving from search, an ad or a shared link could see a price but not buy. snippets/price.liquid
 * now resolves and prints the first available variant, so resolveInitialVariant() below adopts that
 * same variant for the form and enables the button. This is the interim half of the fix; the
 * server-side assignment in blocks/buy-buttons.liquid lands with the Sprint 2 rewrite of that file,
 * after which this function becomes a no-op because the input already has a value.
 */
(function () {
  var EVENT = 'variant:update';
  var BUTTON_PRICE_SELECTOR = '[data-dynamic-price]';
  var MAIN_PRICE_SELECTOR = 'product-price [ref="priceContainer"]';

  function syncCta(state) {
    var btn = document.querySelector('.luxury-add-to-bag-button');
    var text = document.querySelector('[data-purchase-cta]');
    var hint = document.querySelector('[data-purchase-state-hint]');
    if (btn) btn.disabled = state !== 'available';
    if (text) {
      text.textContent = state === 'available' ? 'ADD TO BAG' : state === 'sold_out' ? 'SOLD OUT' : 'SELECT OPTIONS';
    }
    if (hint) {
      if (state === 'available') {
        hint.classList.add('hidden');
        hint.textContent = '';
      } else {
        hint.classList.remove('hidden');
        hint.textContent =
          state === 'sold_out'
            ? 'This combination is currently out of stock. Try another metal or colour, or contact us to restock.'
            : 'Choose metal and colour to see price and availability.';
      }
    }
  }

  function copyMainPriceToButton() {
    var buttonPriceEl = document.querySelector(BUTTON_PRICE_SELECTOR);
    if (!buttonPriceEl) return;
    var section = buttonPriceEl.closest('.shopify-section');
    if (!section) return;
    var mainPriceContainer = section.querySelector(MAIN_PRICE_SELECTOR);
    if (!mainPriceContainer) return;
    buttonPriceEl.innerHTML = mainPriceContainer.innerHTML;
  }

  /**
   * Adopt the variant the server actually priced when the URL carried no ?variant= param.
   * Runs once, and only when the form has no variant of its own, so a real selection is never
   * overwritten. Reads the id straight off the rendered price element, which snippets/price.liquid
   * stamps with data-variant-id for exactly the variant whose price is on screen.
   */
  function resolveInitialVariant() {
    var form = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || idInput.value) return;

    var priceEl = document.querySelector('product-price [data-variant-id]');
    var variantId = priceEl && priceEl.getAttribute('data-variant-id');
    if (!variantId) return;

    /* Prefer the picker's own variant payload when it is present and unambiguous. */
    var payload = document.querySelector('variant-picker script[type="application/json"]');
    var available = true;
    if (payload && payload.textContent) {
      try {
        var parsed = JSON.parse(payload.textContent);
        if (parsed && typeof parsed.available === 'boolean') available = parsed.available;
        if (parsed && parsed.id) variantId = String(parsed.id);
      } catch (_) {
        /* fall through to the price element's id */
      }
    }

    idInput.value = variantId;
    syncCta(available ? 'available' : 'sold_out');
    copyMainPriceToButton();
  }

  function updateButtonPrice(event) {
    var detail = event.detail;
    if (!detail || !detail.data) return;

    var buttonPriceEl = document.querySelector(BUTTON_PRICE_SELECTOR);
    if (!buttonPriceEl) return;

    var productForm = buttonPriceEl.closest('product-form-component');
    var productId = productForm ? productForm.dataset.productId : null;
    if (productId && detail.data.productId && String(detail.data.productId) !== String(productId)) return;

    /* No matching variant: keep bag label only (no stale price from previous selection). */
    if (detail.resource == null) {
      buttonPriceEl.innerHTML = '';
      syncCta('select');
      return;
    }

    syncCta(detail.resource.available ? 'available' : 'sold_out');

    /* Run after product-price has updated from the same event (next microtask) */
    setTimeout(copyMainPriceToButton, 0);
  }

  function start() {
    resolveInitialVariant();
    copyMainPriceToButton();
  }

  function init() {
    document.addEventListener(EVENT, updateButtonPrice);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
